import { Outlet } from "react-router-dom";

import { GuestGuard } from "../../guards/GuestGuard";
import AuthLayout from "../auth/AuthLayout";

const GuestLayout = () => {
    return (
        <GuestGuard>
            <AuthLayout>
                <Outlet />
            </AuthLayout>
        </GuestGuard>
    );
};

export default GuestLayout;